import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  fetchAsyncSearchProduct,
  getSearchProducts,
  getSearchProductsStatus,
  clearSearch,
} from "../../store/searchSlice";
import Loader from "../../components/Loader/Loader";
import ProductList from "../../components/ProductList/ProductList";
import { STATUS } from "../../utils/status";

import LOOSE_IMG from "../../assets/images/loose.jpg"; // Image par défaut



const SearchPage = () => {
  const dispatch = useDispatch();
  const { searchTerm } = useParams();
  const searchProducts = useSelector(getSearchProducts);
  const searchProductsStatus = useSelector(getSearchProductsStatus);

  useEffect(() => {
    dispatch(clearSearch());
    dispatch(fetchAsyncSearchProduct(searchTerm));
  }, [searchTerm, dispatch]);

  if (searchProductsStatus === STATUS.LOADING) {
    return <Loader />;
  }

  if (searchProducts.length === 0) {
    return (
      <div
        className="container"
        style={{
          minHeight: "70vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <img
          src={LOOSE_IMG}
          alt="No Products Found"
          style={{ width: "300px", marginBottom: "20px" }}
        />
        <div className="fw-5 text-danger">
          <h3>No articles found for "{searchTerm}".</h3>
        </div>
      </div>
    );
  }

  return (
    <main>
      <div className="search-content bg-whitesmoke">
        <div className="container">
          <div className="py-5">
            <div className="title-md">
              <h3>Search results:</h3>
            </div>
            <br />
            <ProductList products={searchProducts} />
          </div>
        </div>
      </div>
    </main>
  );
};

export default SearchPage;
